import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isDuplicateListRequestFailure({ uuid }) {
      const req = getState().find(({ list }) => list.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isDuplicateListRequestPending({ uuid }) {
      const req = getState().find(({ list }) => list.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isDuplicateListRequestSuccess({ uuid }) {
      const req = getState().find(({ list }) => list.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
